 
import { Toggleable } from '../toggleable';
import { NoTranslate } from '../../base';
import { CellInnerWrapper, Cell, DeleteCell, RowContainer } from './Base';

export default function Row({ row, index, deleteState, prepareRow }) {
  prepareRow(row);

  const cellContent = (cell) =>
    cell.column.noTranslate ? (
      <NoTranslate>{cell.render('Cell')}</NoTranslate>
    ) : (
      cell.render('Cell')
    );

  const cells = () => {
    return row.cells.map((cell) => (
      // data-title is a DOM attribute, so only pass a text header; a component
      // header (e.g. the Stories Library select-all checkbox) would be invalid.
      <Cell
        {...cell.getCellProps()}
        data-title={typeof cell.column.Header === 'string' ? cell.column.Header : undefined}
      >
        <CellInnerWrapper>{cellContent(cell)}</CellInnerWrapper>
      </Cell>
    ));
  };

  return (
    <RowContainer
      {...row.getRowProps({ even: index % 2 })}
      showDeleteConfirmation={deleteState.isBeingDeleted(index)}
      deleteCancel={deleteState.hideConfirmDelete}
      deleteConfirm={() => {
        deleteState.onDeleteRow(row);
        deleteState.hideConfirmDelete();
      }}
    >
      {cells()}
      <Toggleable show={deleteState.showDelete}>
        <DeleteCell onDelete={() => deleteState.showConfirmDelete(index)} />
      </Toggleable>
    </RowContainer>
  );
}
